import * as z from "zod";

export const alertVolumeProviderSchema = z.enum(["chargeflow", "chargeblast"]);
export type AlertVolumeProvider = z.infer<typeof alertVolumeProviderSchema>;

/**
 * One month of a series. Null draws as a gap rather than a plotted zero, which
 * nothing populates yet — a month before Resolve was running still reports zero.
 */
export const alertVolumeMonthSchema = z.object({
  /** Calendar month, "YYYY-MM". */
  month: z.string(),
  count: z.number().int().nonnegative().nullable(),
});
export type AlertVolumeMonth = z.infer<typeof alertVolumeMonthSchema>;

export const providerAlertVolumeSchema = z.discriminatedUnion("status", [
  z.object({
    status: z.literal("ok"),
    provider: alertVolumeProviderSchema,
    months: z.array(alertVolumeMonthSchema),
  }),
  z.object({
    status: z.literal("error"),
    provider: alertVolumeProviderSchema,
    /** Merchant-facing explanation; never carries the API key or raw payloads. */
    message: z.string(),
  }),
]);
export type ProviderAlertVolume = z.infer<typeof providerAlertVolumeSchema>;

/**
 * Providers the team has not connected are absent from `providers` entirely,
 * which is what lets the card hide rather than render an empty chart.
 */
export const alertProviderVolumeSchema = z.object({
  /** Resolve's own deflection volume, over the same months. */
  deflections: z.array(alertVolumeMonthSchema),
  providers: z.array(providerAlertVolumeSchema),
});
export type AlertProviderVolume = z.infer<typeof alertProviderVolumeSchema>;

export const getAlertProviderVolume = {
  name: "getAlertProviderVolume" as const,
  input: z.object({}),
  output: alertProviderVolumeSchema,
};
